module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rankBg"
  }, [_c('ul', {
    staticClass: "rank_list"
  }, _vm._l((_vm.singerList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.toSingerInfo(index)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(0, true)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rankTitle",
    attrs: {
      "id": "rankTitle"
    }
  }, [_c('i', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/goback_1.png")
    }
  })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.rankTime))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/arrow_icon.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fe22b42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/singer_list.vue
// module id = 101
// module chunks = 0